module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "stage stage--full-size",
    attrs: {
      "data-stage": "4"
    }
  }, [(_vm.opened) ? _c('div', {
    staticClass: "contents detail-stage"
  }, [_c('div', {
    staticClass: "scroll-height"
  }, [_c('booking-summary', {
    attrs: {
      "loading": _vm.loading,
      "error": _vm.error,
      "status": _vm.status || null,
      "venue": _vm.booking.venue,
      "pax": _vm.booking.pax,
      "date": _vm.booking.date,
      "type": _vm.booking.type,
      "times": _vm.booking.times,
      "preorder-payment-msg": _vm.preorderAndPaymentMsg || null
    },
    on: {
      "changeDetails": _vm.changeDetails,
      "findAlternatives": _vm.findAlternatives
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "enquire-separator"
  }), _vm._v(" "), _c('form', [(!_vm.loading && !_vm.error) ? [(_vm.bookingDetails.offers.length) ? _c('offers-input', {
    attrs: {
      "offers": _vm.bookingDetails.offers
    },
    model: {
      value: (_vm.$root.booking.offer),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "offer", $$v)
      },
      expression: "$root.booking.offer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bookingDetails.packages.length) ? _c('package-input', {
    attrs: {
      "packages": _vm.bookingDetails.packages
    },
    model: {
      value: (_vm.$root.booking.package),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "package", $$v)
      },
      expression: "$root.booking.package"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.status !== _vm.TimeAction.reject) ? _c('user-details-form', {
    ref: "userForm",
    attrs: {
      "booking-details": _vm.bookingDetails
    },
    on: {
      "openModal": _vm.openModal,
      "bookingSent": _vm.bookingSent
    },
    model: {
      value: (_vm.$root.booking.user),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "user", $$v)
      },
      expression: "$root.booking.user"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bookingDetails.hasCustomField) ? _c('custom-field', {
    attrs: {
      "label": _vm.bookingDetails.customFieldLabel
    },
    model: {
      value: (_vm.$root.booking.customField),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "customField", $$v)
      },
      expression: "$root.booking.customField"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bookingDetails.hasTagFields) ? _c('tags-input', {
    attrs: {
      "fields": _vm.bookingDetails.tagFields
    },
    model: {
      value: (_vm.$root.booking.tags),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "tags", $$v)
      },
      expression: "$root.booking.tags"
    }
  }) : _vm._e(), _vm._v(" "), _c('special-request', {
    model: {
      value: (_vm.$root.booking.specialRequest),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "specialRequest", $$v)
      },
      expression: "$root.booking.specialRequest"
    }
  }), _vm._v(" "), _c('marketing-checkboxes', {
    attrs: {
      "show-preferences": !_vm.loggedIn,
      "show-dmn": !_vm.loggedIn && _vm.bookingDetails.shouldShowNewsletterSignup,
      "partner-msg": _vm.bookingDetails.getCustomMarketingOptInMsg,
      "preferences": _vm.bookingDetails.marketingPreferences
    },
    model: {
      value: (_vm.$root.booking.marketing),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "marketing", $$v)
      },
      expression: "$root.booking.marketing"
    }
  }), _vm._v(" "), (_vm.bookingDetails.hasBookingPolicy) ? _c('booking-policy', {
    ref: "policyCheckbox",
    attrs: {
      "policy": _vm.bookingDetails.bookingPolicy
    },
    model: {
      value: (_vm.$root.booking.policyConfirm),
      callback: function($$v) {
        _vm.$set(_vm.$root.booking, "policyConfirm", $$v)
      },
      expression: "$root.booking.policyConfirm"
    }
  }) : _vm._e(), _vm._v(" "), _c('submit-booking-button', {
    attrs: {
      "disabled": _vm.disableSubmitBtn,
      "label": _vm.submitButtonTxt
    },
    on: {
      "click": _vm.submitForm
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.error) ? [_c('p', [_vm._v("An error occurred when checking availability for this booking.")])] : _vm._e()], 2)], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93ba6d7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailsStage.vue
// module id = 610
// module chunks = 0